import React from 'react';
import { useParams } from 'react-router-dom';
import { Dashboard } from '@components/common/Dashboard';
import { PageLayout } from '@components/common/PageLayout';
import { DashboardBackButton } from '@components/utils';
import { SECTION_NAMES } from '@constants/sectionNames';
import { ButtonClean, HeadContent, Loading, useModalContext } from '@fourthwall/components';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { routing } from '@utils/routing';
import { ConnectBar } from '../../components/ConnectBar/ConnectBar';
import { SettingsIframe } from './components/SettingsIframe';
import { usePlatformApp } from './hooks/usePlatformApp';
export const AppsPlatformUnified = (props) => {
    const { app: appId } = useParams();
    const { connectBar, isLoading, hmac, name, settingsUrl, description, learnMoreUrl } = usePlatformApp(props.appId || appId || '');
    const { currentShop } = useCurrentShop();
    const { open: openModal } = useModalContext();
    if (!connectBar || !currentShop) {
        return React.createElement(Loading, { isLoading: isLoading });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: name }),
        React.createElement(PageLayout, { size: "tiny" },
            React.createElement(Dashboard.Section, { name: name, topContent: React.createElement(DashboardBackButton, { label: SECTION_NAMES.apps, to: routing.apps.self }), bottomContent: React.createElement("p", null,
                    description,
                    ' ',
                    learnMoreUrl && (React.createElement(ButtonClean, { label: "Learn More", href: learnMoreUrl, target: "_blank" }))) },
                React.createElement(Loading, { isLoading: isLoading },
                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 16 } },
                        React.createElement(ConnectBar, { ...connectBar }),
                        hmac && settingsUrl ? (React.createElement(SettingsIframe, { hmac: hmac, shopId: currentShop?.id, openModal: openModal, settingsUrl: settingsUrl, name: name || '' })) : (React.createElement("p", null))))))));
};
